import App from './App.html'
const interval = 5000;
const tick = 50;
const maxBars = 14;
function speedToColor(speed) {
  if (speed < 1000) return 'green'
  if (speed < 2000) return 'yellow'
  if (speed < interval) return 'red'
  return 'black'
}

function renderSpeed ({speed, id}) {
  return {
    id,
    speed,
    style: `height: ${Math.floor(1 + speed / (interval/100))}px; background-color: ${speedToColor(speed)};`
  }
}

const allSpeeds = []

let newMeasure = {
  speed: 0,
  id: Math.random()
};
let t = 0;

const app = new App({
  target: document.body,
  data: {
    speeds: allSpeeds.map(renderSpeed),
    time: 0,
    maxBars,
    paddingLeft: '18px',
    newMeasure
  }
})

let running = true
let fail = false

function resetCounterFake() {
  const time = Math.floor(Math.random() * interval)
  console.log('time:', time)
  running = true
  setTimeout(() => {
    running = false
  }, time)
}

function resetCounter() {
  fail = false
  running = true
  fetch('http://webup.info/up')
    .then(() => {running = false})
    .catch(() => {fail = true})
}

resetCounter()

setInterval(() => {
  t += tick

  if (fail) {
    newMeasure.speed = interval
  } else if (running) {
    newMeasure.speed += tick
  }

  if (t >= interval) {
    allSpeeds.unshift(newMeasure)
    newMeasure = {
      speed: 0,
      id: Math.random()
    };

    resetCounter()
    t = 0
  }

  const speeds = [newMeasure, ...allSpeeds]
    .filter((_, i) => i <= maxBars)
    .map(renderSpeed)
  const paddingLeft = (t/interval*18)
  app.set({newMeasure, speeds, paddingLeft})
  drawFavIcon([newMeasure, ...allSpeeds])
}, tick)

function drawFavIcon (speeds) {
  var favicon = document.getElementById('favicon');
  var faviconSize = 16;

  var canvas = document.createElement('canvas');
  canvas.width = faviconSize;
  canvas.height = faviconSize;
  var context = canvas.getContext('2d');

  context.beginPath();
  context.rect(0,0, 16, 16);
  context.strokeStyle = 'black';
  context.stroke();

  window.document.title = speeds[0].speed
  for(let i=0; i<speeds.length && i<14; i++) {
    const speed = speeds[i].speed
    // Draw Notification Circle
    context.beginPath();
    context.moveTo(i+1, 15)
    context.lineTo(i+1, 15 - Math.floor(14 * (speed / interval)))
    context.strokeStyle = speedToColor(speed)
    context.stroke();
  }

  // Replace favicon
  favicon.href = canvas.toDataURL('image/png');
  console.log(canvas.toDataURL('image/png'))

    
};

export default app
